import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Destination, WarehouseDestinationResponse } from 'src/app/models/destination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { DestinationService } from 'src/app/services/destination.service';
import { WarehouseService } from 'src/app/services/warehouse.service';

@Component({
  selector: 'app-association-destination-warehouses',
  templateUrl: './association-destination-warehouses.component.html',
  styleUrls: ['./association-destination-warehouses.component.scss']
})
export class AssociationDestinationWarehousesComponent implements OnInit {
  warehouses: WarehouseResponse[] = [];
  filterWarehouse: WarehouseResponse[] = [];
  destinations: Destination[] = [];
  filterDestination: Destination[] = [];
  assigsActive: WarehouseDestinationResponse [] = []

  inputs = {
    warehouse: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null,
        name: '',
      }
    },
    destination: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    }
  }
  loadingCreate = false;
  loadingAssings = false;
  startDate = new Date().toLocaleDateString('en-CA');
  endDate = new Date().toLocaleDateString('en-CA');

  constructor(
    private warehouseService: WarehouseService,
    private destinationService: DestinationService,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {
    this.getWarehouses('');
    this.getDestinations();
  }

  getWarehouses(searchValue: string) {
    this.warehouseService.getWarehouseByClue(searchValue).subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.filterWarehouse = this.warehouses;

        if (this.filterWarehouse.length == 0) {
          this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
        } else if (this.filterWarehouse.length == 1) {
          this.changeInput(this.inputs.warehouse, this.filterWarehouse[0].name, true, null, 'fa-circle-check', this.filterWarehouse[0]);
        } else {
          this.changeInput(this.inputs.warehouse, searchValue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al obtener las bodegas", "Error");
      }
    });
  }

  getDestinations() {
    this.destinationService.getDestinationsActive(true).subscribe({
      next: (response: ResponseObject) => {
        this.destinations = response.data;
        this.filterDestination = this.destinations;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al obtener las bodegas", "Error");
      }
    });
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }

  writeWarehouse(input) {
    const inputValue = input.target.value;

    this.filterWarehouse = this.warehouses.filter((w) =>
      w.name.toLowerCase().includes(inputValue.toLowerCase())
      || w.code.toLowerCase().includes(inputValue.toLowerCase())
    );

    if (this.filterWarehouse.length == 0) {
      this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
    } else if (this.filterWarehouse.length == 1) {
      this.changeInput(this.inputs.warehouse, this.filterWarehouse[0].name, true, null, 'fa-circle-check', this.filterWarehouse[0]);
    } else {
      this.changeInput(this.inputs.warehouse, input.target.value, false, null, 'fa-list', null);
    }
  }

  checkWarehouse(warehouse: WarehouseResponse) {
    this.inputs.warehouse.class = "fa-circle-check";
    this.inputs.warehouse.verified = true;
    this.inputs.warehouse.data = warehouse;
    this.inputs.warehouse.value = warehouse.name;

    this.getWarehouseDestinatinoToday();
  }

  writeDestination(input) {
    const inputValue = input.target.value;

    this.filterDestination = this.destinations.filter((w) =>
      w.name.toLowerCase().includes(inputValue.toLowerCase())
    );

    if (this.filterDestination.length == 0) {
      this.changeInput(this.inputs.destination, null, false, null, 'fa-xmark', null);
    } else if (this.filterDestination.length == 1) {
      this.changeInput(this.inputs.destination, this.filterDestination[0].name, true, null, 'fa-circle-check', this.filterDestination[0]);
    } else {
      this.changeInput(this.inputs.destination, input.target.value, false, null, 'fa-list', null);
    }
  }

  checkDestination(destination: Destination) {
    this.inputs.destination.class = "fa-circle-check";
    this.inputs.destination.verified = true;
    this.inputs.destination.data = destination;
    this.inputs.destination.value = destination.name;
  }


  createAddAsociation() {
    if (!this.inputs.warehouse.verified || !this.inputs.destination.verified || !this.startDate || !this.endDate) {
      return;
    }

    if (this.startDate > this.endDate) {
      this.toastrService.warning("La fecha de inicio no puede ser mayor a la fecha fin");
      return;
    }

    const currentDate = new Date().toLocaleDateString('en-CA');
    
    console.log(this.startDate, '<', currentDate);
    
    if (this.startDate < currentDate) {
      this.toastrService.warning("La fecha de inicio no puede ser menor a la fecha actual");
      return;
    }

    const warehouseId = this.inputs.warehouse.data.id;
    const destinationId = this.inputs.destination.data.id;
    const data = {
      startDate: this.startDate,
      endDate: this.endDate
    }
    this.loadingCreate = true;

    this.destinationService.createDestinationWareshouseWithDates(destinationId, warehouseId, data).subscribe({
      next: (response: ResponseObject) => {
        this.toastrService.success("Destino asignado a bodega correctamente");
        this.loadingCreate = false;
        this.resetForm();
        this.getWarehouseDestinatinoToday();
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al asignar el destino a la bodega");
        this.loadingCreate = false;
      }
    });
  }

  getWarehouseDestinatinoToday() {
    if (!this.inputs.warehouse.verified) {
      return;
    }
    this.loadingAssings = true;
    this.destinationService.getWarehouseDestinationsWithUserByEffectiveDateAndWarehouseToday(this.inputs.warehouse.data.id).subscribe({
      next: (response: ResponseObject) => {
        this.assigsActive = response.data ?? [];
        this.loadingAssings = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al obtener asignaciones de la bodega",this.inputs.warehouse.data.name);
        this.loadingCreate = false;
        this.loadingAssings = false;
      }
    });
  }

  resetForm() {
    this.startDate = new Date().toLocaleDateString('en-CA');
    this.endDate = new Date().toLocaleDateString('en-CA');
  }

  get verifyForm() {
    if (this.inputs.destination.verified && this.inputs.warehouse.verified && this.startDate && this.endDate) {
      return true;
    }
    return false;
  }
}
